import styled from 'styled-components';

const LoginBottom = styled.div`
  max-width: 967px;
  overflow: hidden;
  margin: 0 auto 37px;
  position: relative;
  border-radius: 0 0 20px 20px;
  background-color: #fff;
  padding: 12px 25px;
  @media screen and (max-width: 576px) {
    padding: 40px 20px;
  }
`;

export default LoginBottom;



// WEBPACK FOOTER //
// ./app/containers/Login/components/LoginBottom/index.js